import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import globalSnackbarReducer from './snackBarSlice';
import selectedIdReducer from './selectedIdSlice';

export default configureStore({
  reducer: {
    user: userReducer,
    globalSnackbar: globalSnackbarReducer,
    selectedId: selectedIdReducer,
  },
});
